import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {
  ActiveOrganizationWatchService,
  OrganizationMismatch,
} from '../../shared/services/active-organization-watch.service';

/** Stay-or-switch prompt for an active organization changed elsewhere; no way to dismiss it unanswered. */
@Component({
  selector: 'goatsports-organization-changed-dialog',
  imports: [DialogModule, ButtonModule, TranslocoDirective],
  templateUrl: './organization-changed-dialog.component.html',
  styleUrls: ['./organization-changed-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationChangedDialogComponent {
  private readonly watcher = inject(ActiveOrganizationWatchService);

  mismatch = input.required<OrganizationMismatch>();

  readonly isBusy = signal(false);

  async stay() {
    this.isBusy.set(true);
    try {
      await this.watcher.stay();
    } catch {
      // Could not point the server back (e.g. access revoked meanwhile): follow the change instead.
      this.watcher.reload();
    }
  }

  switch() {
    this.isBusy.set(true);
    this.watcher.reload();
  }
}
